<!--
 * @Copyright: Copyright (c) 2021 Yihua, All right is reserverd
 * @name: Bodies
 * @Description: 内容区
 * @FilePath: /app-tikfriend_web/src/components/Bodies.vue
 * @Version: 0.1.0
 * @Autor: hselenat
 * @Date: 2021-04-28 07:42:52
 * @LastEditors: hselenat
 * @LastEditTime: 2021-07-09 10:26:35
 * @example: 调用示例
-->
<template>
  <section class="container-x">
    <div class="main-x">
      <div class="content-x">
        <div class="des-x">
          <div v-for="(item, index) in curData.conetent" :key="index">
            <span class="des-title">{{ item.title }}</span>
            <span>{{ item.descript }}</span></div>
				</div>
				<div class="info-x">
					<div class="slogan">
						<div class="slogan-title">{{ curData.title }}</div>
						<div class="slogan-subtitle">{{ curData.slogan }}</div>
					</div>
					<div class="down-x">
						<div class="qrcode"><img :src="require('@/assets/' + curData.qrcodeImg)" :title="curData.compName" :alt="curData.compName" /></div>
						<div class="down-btn-x">
							<a :href="curData.iOSUrl"
								class="down-btn bg-blue" title="App Store" v-if="curSystem != 'Android' || curSystem == 'other'">
								<img src="../assets/apple@2x.png" class="icon icon_down" /><span>App Store</span>
							</a>
              <a :href="curData.androidUrl"
								class="down-btn bg-green" title="Android" v-if="curSystem != 'iOS' || curSystem == 'other'">
								<img src="../assets/android@2x.png" class="icon icon_down" /><span>Android</span>
							</a>
              <a :href="curData.windowsUrl"
								class="down-btn bg-white01" title="Windows" v-if="isShowWindows && curSystem == 'other'">
								<img src="../assets/win@2x.png" class="icon icon_down" /><span>Windows</span>
							</a>
						</div>
					</div>
				</div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'Bodies',
    props: {
      curPage: {
        type: String,
        default: 'chat'
      },
      curData: {
        type: Object,
        default: () => {}
      },
      isShowWindows: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        curSystem: localStorage.getItem('curSystem')
      }
    },
    methods: {
      gotoPage(item, index) {
        console.log(item, index)
        this.curCompName = item.compName
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Bodies.vue